import { render, staticRenderFns } from "./OperaIdentityDetailWindow.vue?vue&type=template&id=b8a361dc&scoped=true&"
import script from "./OperaIdentityDetailWindow.vue?vue&type=script&lang=js&"
export * from "./OperaIdentityDetailWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaIdentityDetailWindow.vue?vue&type=style&index=0&id=b8a361dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a361dc",
  null
  
)

export default component.exports